export default {
  productsInCart(state) {
    return state.products;
  },
  subtotal(state) {
    return state.subtotal;
  }
}